import { useMemo } from 'react';

import { EnvConfig } from 'config/envConfig';
import { ContactNotePartner, ContactNoteRelatedBR } from 'types/ContactNote';
import { isDigit } from 'utils/stringUtil';

type Entity = Record<string, any>;
export type Filters = Record<string, any[]>;

const useKeyFilter = (entities: Entity[], filters: Filters) => {
  const filteredEntries = useMemo(() => {
    return entities.filter((d) => {
      if (EnvConfig.config.createContactNoteNewUiEnabled) {
        return Object.entries(filters).every(([key, val]) => {
          if (Array.isArray(val)) {
            if (key === 'relatedPartners') {
              if (val.includes('') && d[key].length === 0) {
                return true;
              }
              const list = d[key]?.map((item: ContactNotePartner) => item.fullName);
              return val.some((item) => {
                if (item.includes(', ')) {
                  const itemList = item.split(', ');
                  return (itemList as string[]).every((label) => list.includes(label));
                }
                return list.includes(item);
              });
            }
            if (key === 'relatedBRs') {
              if (val.includes('') && d[key].length === 0) {
                return true;
              }
              const list = d[key]?.map((item: ContactNoteRelatedBR) => {
                if (isDigit(item.masterNumber)) {
                  return `${item.masterNumber?.slice(0, 4)}.${item.masterNumber?.slice(4)}`;
                }
                return item.masterNumber || 'Prospecting BR';
              });
              return val.some((item) => {
                if (item.includes(', ')) {
                  const itemList = item.split(', ');
                  return (itemList as string[]).every((label) => list.includes(label));
                }
                return list.includes(item);
              });
            }

            if (key === 'createdByFullName') {
              const creatorLabel = `${d?.createdByFullName || 'N/A'} (${d?.createdBy})`;
              return val.includes(creatorLabel);
            }

            return Array.isArray(val) ? val.includes(d[key]) : false;
          }
        });
      }
      return entities.filter((d) =>
        Object.entries(filters).every(([key, val]) => (Array.isArray(val) ? val.includes(d[key]) : false)),
      );
    });
  }, [entities, filters]);

  return [filteredEntries];
};

export default useKeyFilter;
